import { DocAssociation } from '@core/classes/SharedEnums';
import DocumentAssociation from '@core/classes/DocumentAssociation';
import { SaturnPermissions } from '@core/classes/AccessEmployeeClass';

export enum DocumentAuditLogStatus {
	Unknown = 'unknown',
	Created = 'created',
	Archived = 'archived',
	Recovered = 'recovered',
}

export interface IUploadedDocument {
	id: string;
	associations: DocumentAssociation[];
	azureFilepathInfo: IAzureFilepath;
	docInfo: IDocumentInfo;
	auditTrail: IDocumentAuditLog[];
}

export interface IAzureFilepath {
	shareName: string;
	directoryPath: string;
}

export interface IDocumentInfo {
	/** The name of the file (note: should match the file name uploaded to Azure) */
	fileName: string;

	/** A MIME type string */
	fileType: string;

	/** Where did this document come from? (ex. manual upload, Plaid, 3rd party API, etc.) */
	source: string;

	/** What kind of document is this? */
	docType: string;

	/** List of all past manual verifications associated with this document */
	manualVerifications: IDocumentVerification[];

	timestamp: string;
}

export interface IDocumentVerification {
	/** When true, indicates that this document was manually verified. Otherwise, indicates that this document has been manually rejected. */
	isVerified: boolean;

	/** User details of the employee who submitted this manual verification */
	verifiedBy: {
		employeeNumber: string;
		employeeName: string;
	};

	/** Permissions of the employee who submitted this manual verification */
	verifierPermissions: SaturnPermissions;

	/** Timestamp when this manual verification was submitted */
	timestamp: string;

	/** For some manual verifications, the user will be shown a list of fields to match against the uploaded document. This is that list. May not be applicable for all documents. */
	fieldsMatchedAgainst?: { key: string; value: string }[];
}

export interface IDocumentAuditLog {
	/** Time this status update occurred */
	timestamp: Date;

	/** The new status of this document */
	status: DocumentAuditLogStatus;

	/** The type of person / process that updated this document */
	updaterType: DocAssociation;

	/** The name of the person / process that updated this document */
	statusUpdatedBy: string;

	/**
	 * An ID to help identify the specific person / process that updated this document. Dependent on what the `updaterType` is.
	 * May not be available in all scenarios.
	 */
	updaterId?: string;
}
